export const alertPopUpInitiator = {
  isOpen: false,
  messageType: "",
  titleMessage: "",
  detailMessage: "",
};

export const topStripInitiator = {
  isShow: false,
  isSuccess: false,
  isWarning: true,
  content: "",
};
